import React from 'react';
import './ResizableTable.css';

/**
 * ResizableHeader
 *
 * Renders a single <th> with a drag handle on its right edge.
 *
 * Props:
 *   colKey      - the column key used with onMouseDown
 *   width       - current pixel width
 *   onMouseDown - handler from useResizableColumns
 *   className   - extra class names
 *   style       - extra inline styles
 *   children    - header label
 */
export function ResizableHeader({ colKey, width, onMouseDown, className = '', style = {}, children }) {
  return (
    <th
      className={`resizable-th ${className}`}
      style={{
        width,
        minWidth: width,
        maxWidth: width,
        position: 'relative',
        userSelect: 'none',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...style,
      }}
    >
      {children}
      <span
        className="col-resize-handle"
        onMouseDown={(e) => onMouseDown(colKey, e)}
        title="Drag to resize column"
      />
    </th>
  );
}

/**
 * ResizableTable
 *
 * Drop-in wrapper. Renders a <table> with layout="fixed" so column widths are respected.
 */
export function ResizableTable({ tableRef, className = '', style = {}, children }) {
  return (
    <div className="resizable-table-container">
      <table
        ref={tableRef}
        className={`table resizable-table ${className}`}
        style={{ tableLayout: 'fixed', width: '100%', ...style }}
      >
        {children}
      </table>
    </div>
  );
}
